import { useCallback, useContext, useEffect, useState } from 'react';
import MultisportApiContext from '../contexts/MultisportApiContext';
import { IMultisportCompetition, RefreshTimes } from '../../../../packages/types';
import useFetchIntervalData from '../../../../packages/hooks/useFetchIntervalData';

interface IUseCompetitionsArgs {
  date: string;
  dataRefreshTime?: RefreshTimes;
  showTopEventsAndCompetitionsOptions?: boolean;
}

export default function useCompetitions({ date, dataRefreshTime, showTopEventsAndCompetitionsOptions }: IUseCompetitionsArgs) {
  const { $multisport } = useContext(MultisportApiContext);
  const [competitionsData, setCompetitionsData] = useState<IMultisportCompetition[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchCompetitions = useCallback(
    (manageLoader: boolean) => {
      if (showTopEventsAndCompetitionsOptions) {
        manageLoader && setIsLoading(true);
        $multisport
          ?.competitions({
            date,
          })
          ?.then((res) => {
            manageLoader && setIsLoading(false);
            if (res && res.length > 0) {
              setCompetitionsData(res);
            }
          })
          .catch((error: unknown) => {
            console.error(error);
          });
      }
    },
    [$multisport, date, showTopEventsAndCompetitionsOptions],
  );

  const refetchWidgetData = useFetchIntervalData(fetchCompetitions, dataRefreshTime);

  useEffect(() => {
    fetchCompetitions(true);
  }, [fetchCompetitions]);

  return { competitions: competitionsData, isLoading, refetchWidgetData };
}
